/// <amd-module name="Repos/CommitActions/CommitActionsService" />
import * as React from "react";
import { GitRepository } from "Repos/Common/Contracts/Git";
import { getReposRoutingService } from "Repos/Common/ReposRoutingService";
import { IVCViewModelDataProviderService } from "Repos/Common/VCViewModelDataProviderService";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { ITableRow } from "VSSUI/Table";
import { SearchForCommitPanel } from "./Components/SearchForCommitPanel";
import { ICommitActionsService, ISearchStatusItem } from "./Contracts";

class CommitActionsService extends VssService implements ICommitActionsService {
    private repository: GitRepository;

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        const vcViewModelDataProviderService = this.pageContext.getService<IVCViewModelDataProviderService>("IVCViewModelDataProviderService");
        this.repository = vcViewModelDataProviderService.getRepository()!;
    }

    public searchForCommit(commitId: string, repository: GitRepository): void {
        this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager").renderCallout((onDismiss: () => void) => {
            return (
                <SearchForCommitPanel
                    commitId={commitId}
                    initialTargetBranch={repository.defaultBranch}
                    onActivate={this.onNavigateToItem}
                    onDismiss={() => {
                        onDismiss();
                    }}
                    repository={repository}
                />
            );
        });
    }

    private onNavigateToItem = (event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<ISearchStatusItem>) => {
        if (!event.defaultPrevented) {
            const routeService = getReposRoutingService(this.pageContext);
            const url = routeService.getFilesUrl(this.repository.name, this.repository.project.name, undefined, tableRow.data.versionDescriptor);
            onClickFPS(this.pageContext, url, true, event);
        }
    };
}

Services.add("ICommitActionsService", { serviceFactory: CommitActionsService });
